<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 15:43:57
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 16:27:14
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/list/components/tableCells/relatedGoodsCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex-row" v-if="row.productList && row.productList.length > 0">
			<el-tooltip
				v-for="(item, index) in row.productList.slice(0, 2)"
				:key="index"
				class="item"
				effect="dark"
				:content="index ? '查看全部关联商品' : '查看商品源链接'"
				placement="top"
				:open-delay="300"
			>
				<div class="pos-rela radius-4 cursor-pointer" :class="{ 'ml-4': index }" style="overflow: hidden">
					<div @click="() => productPicClick(item, !index, row)">
						<rd-img imgType="good" :size="40" :src="item.productPicUrl"></rd-img>
					</div>
					<div class="mask flex-center" v-if="index" @click="() => productPicClick(item, !index, row)">+{{ row.productList.length - 1 }}</div>
				</div>
			</el-tooltip>
		</div>
		<div v-else>-</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';

export default {
	name: 'relatedGoodsCell',
	mixins: [mixin],
	data() {
		return {};
	},
	components: {},
	computed: {},
	props: {},

	mounted() {},

	methods: {
		productPicClick(goods, isLinkToThirdUrl, row) {
			let url = isLinkToThirdUrl
				? goods.productUrl
				: this.$router.resolve({
						path: '/shopManage/shopLibrary/list',
						query: {
							materialId: row.id,
							platformId: goods.platformId,
						},
				  }).href;
			window.open(url, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.mask {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.6);
	color: #fff;
}
</style>
